<div class="container">
  <mat-card>
    <form [formGroup]="collateralForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (collateralForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Type/Quality' | translate }}</mat-label>
            <input matInput required formControlName="quality" />
            @if (collateralForm.controls.quality.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Type/Quality' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Unit Type' | translate }}</mat-label>
            <input matInput required formControlName="unitType" />
            @if (collateralForm.controls.unitType.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Unit Type' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Base Price' | translate }}</mat-label>
            <input matInput required formControlName="basePrice" />
            @if (collateralForm.controls.basePrice.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Base Price' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Percentage to Base' | translate }}</mat-label>
            <input matInput required formControlName="pctToBase" />
            @if (collateralForm.controls.pctToBase.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Percentage to Base' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.heading.Currency' | translate }}</mat-label>
            <mat-select required formControlName="currency">
              @for (currency of collateralTemplateData; track currency) {
                <mat-option [value]="currency.code">
                  {{ currency.name }}
                </mat-option>
              }
            </mat-select>
            @if (collateralForm.controls.currency.hasError('required')) {
              <mat-error>
                {{ 'labels.heading.Currency' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!collateralForm.valid"
          *LOSxHasPermission="'CREATE_CHARGE'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
